import { useModalBaseContext } from "./auth-service-tools286.js";
const DEFAULT_TRANSITION = {
  duration: 200,
  timingFunction: "ease",
  transition: "fade"
};

function useModalTransition(transitionOverride) {
  const ctx = useModalBaseContext();
  return { ...DEFAULT_TRANSITION,
    ...ctx.transitionProps,
    ...transitionOverride
  };
}

export { useModalTransition };